/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileUploadDto } from './FileUploadDto';
import {
    FileUploadDtoFromJSON,
    FileUploadDtoFromJSONTyped,
    FileUploadDtoToJSON,
} from './FileUploadDto';

/**
 * 
 * @export
 * @interface AnneeFormationSuivieFichierUploadDto
 */
export interface AnneeFormationSuivieFichierUploadDto {
    /**
     * 
     * @type {FileUploadDto}
     * @memberof AnneeFormationSuivieFichierUploadDto
     */
    file?: FileUploadDto;
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieFichierUploadDto
     */
    idanneeFormationSuivieFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieFichierUploadDto
     */
    idanneeFormationSuivie?: number;
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieFichierUploadDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieFichierUploadDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof AnneeFormationSuivieFichierUploadDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the AnneeFormationSuivieFichierUploadDto interface.
 */
export function instanceOfAnneeFormationSuivieFichierUploadDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AnneeFormationSuivieFichierUploadDtoFromJSON(json: any): AnneeFormationSuivieFichierUploadDto {
    return AnneeFormationSuivieFichierUploadDtoFromJSONTyped(json, false);
}

export function AnneeFormationSuivieFichierUploadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnneeFormationSuivieFichierUploadDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : FileUploadDtoFromJSON(json['file']),
        'idanneeFormationSuivieFichier': !exists(json, 'idanneeFormationSuivieFichier') ? undefined : json['idanneeFormationSuivieFichier'],
        'idanneeFormationSuivie': !exists(json, 'idanneeFormationSuivie') ? undefined : json['idanneeFormationSuivie'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function AnneeFormationSuivieFichierUploadDtoToJSON(value?: AnneeFormationSuivieFichierUploadDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': FileUploadDtoToJSON(value.file),
        'idanneeFormationSuivieFichier': value.idanneeFormationSuivieFichier,
        'idanneeFormationSuivie': value.idanneeFormationSuivie,
        'idfichier': value.idfichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'fileName': value.fileName,
    };
}

